import { createFileRoute } from '@tanstack/react-router'
import ErrorComponent from '@/features/errors/error-component'
import { zodValidator } from '@tanstack/zod-adapter'
import Index from '@/features/region/cities/pages'
import { searchQueryOptions } from '@/features/region/cities/query-options'
import { SearchSchema } from '@/features/region/cities/schemas/search'

export const Route = createFileRoute('/_authenticated/(region)/cities')({
  component: Index,
  validateSearch: zodValidator(SearchSchema),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, deps }) => {
    const { queryClient } = context
    await queryClient.ensureQueryData(
      searchQueryOptions({ key: 'cities', search: deps })
    )
  },
  errorComponent: ({ error }) => {
    return <ErrorComponent error={error} />
  },
})
